import { Chip as MuiChip, ChipProps as MuiChipProps } from "@mui/material"
import React from "react"

export interface ChipProps extends MuiChipProps {
  shape?: "rounded" | "circle"
}
const config = Object.freeze({
  rounded: {
    borderRadius: "50px",
    px: 0.5,
    py: 0.5,
    "& .MuiChip-label": {
      px: 1,
    },
  },
  circle: {
    borderRadius: "50%",
    px: 0,
    py: 0.5,
    width: 32,
    height: 32,
    "& .MuiChip-label": {
      px: 0,
    },
  },
})
export const Chip = React.forwardRef(
  (props: ChipProps, ref: React.ForwardedRef<HTMLDivElement>) => {
    const { shape = "rounded", sx, ...rest } = props
    return (
      <MuiChip
        ref={ref}
        data-testid="testChip"
        sx={{
          ...config[shape],
          ...sx,
        }}
        {...rest}
      />
    )
  },
)

Chip.displayName = "Chip"
